"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The MailgunStorageInfo model module.
 * @module model/MailgunStorageInfo
 * @version 1.1.3-alpha.1
 */
class MailgunStorageInfo {
  /**
   * Constructs a new <code>MailgunStorageInfo</code>.
   * @alias module:model/MailgunStorageInfo
   */
  constructor() {
    MailgunStorageInfo.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>MailgunStorageInfo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MailgunStorageInfo} obj Optional instance to populate.
   * @return {module:model/MailgunStorageInfo} The populated <code>MailgunStorageInfo</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MailgunStorageInfo();
      if (data.hasOwnProperty('url')) {
        obj['url'] = _ApiClient.default.convertToType(data['url'], 'String');
      }
      if (data.hasOwnProperty('key')) {
        obj['key'] = _ApiClient.default.convertToType(data['key'], 'String');
      }
      if (data.hasOwnProperty('region')) {
        obj['region'] = _ApiClient.default.convertToType(data['region'], 'String');
      }
      if (data.hasOwnProperty('env')) {
        obj['env'] = _ApiClient.default.convertToType(data['env'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>MailgunStorageInfo</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MailgunStorageInfo</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['url'] && !(typeof data['url'] === 'string' || data['url'] instanceof String)) {
      throw new Error("Expected the field `url` to be a primitive type in the JSON string but got " + data['url']);
    }
    // ensure the json data is a string
    if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
      throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
    }
    // ensure the json data is a string
    if (data['region'] && !(typeof data['region'] === 'string' || data['region'] instanceof String)) {
      throw new Error("Expected the field `region` to be a primitive type in the JSON string but got " + data['region']);
    }
    // ensure the json data is a string
    if (data['env'] && !(typeof data['env'] === 'string' || data['env'] instanceof String)) {
      throw new Error("Expected the field `env` to be a primitive type in the JSON string but got " + data['env']);
    }
    return true;
  }
}

/**
 * @member {String} url
 */
MailgunStorageInfo.prototype['url'] = undefined;

/**
 * @member {String} key
 */
MailgunStorageInfo.prototype['key'] = undefined;

/**
 * @member {String} region
 */
MailgunStorageInfo.prototype['region'] = undefined;

/**
 * @member {String} env
 */
MailgunStorageInfo.prototype['env'] = undefined;
var _default = MailgunStorageInfo;
exports.default = _default;